function dataUriToBlob(sUri) {
    let byteString;
    const [, payload = ""] = sUri.split(",");
    if (sUri.split(",")[0].indexOf("base64") >= 0) {
        byteString = window.atob(payload);
    } else {
        byteString = unescape(payload);
    }
    const [header = ""] = sUri.split(",");
    const [mimePart = ""] = header.split(":");
    const [type = ""] = mimePart.split(";");
    const ia = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++){
        ia[i] = byteString.charCodeAt(i);
    }
    return new window.Blob([
        ia
    ], {
        type
    });
}
export { dataUriToBlob };
